import { Route, Switch } from "react-router-dom";
import OfferProductsAdmin from "./OfferProductsAdmin";
import OfferProductDetailsAdmin from "./OfferProductDetailsAdmin";
import OfferProductAdminView from "./OfferProductAdminView";

const App = ({ match }) => (
    <Switch>
        <Route exact path={`${match.url}`} component={OfferProductsAdmin} />
        <Route
            path={`${match.url}/add-edit/:id?`}
            component={OfferProductDetailsAdmin}
        />
        <Route path={`${match.url}/view/:id?`} component={OfferProductAdminView} />
    </Switch>
)

export default App;